module.exports = __webpack_public_path__ + "static/media/ic_hospicash_b1_fisdom.80eee2c1.svg";